import {Component} from '@angular/core';
import {TimezoneService} from "../../../services/timezone-service";
import {OrganizationService} from "../../../services/organization.service";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-form',
  templateUrl: './company-form.component.html'
})
export class CompanyFormComponent extends AbstractProdForm {
  title: string = this.translate.instant('organizations.company_form.title');
  style = {labelWidth: '200px'};
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('organizations.company_form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
    }),
    ProdFormField.create({
      name: 'description',
      label: this.translate.instant('organizations.company_form.description'),
      type: ProdFormFieldType.TEXTAREA,
    }),
    ProdFormField.create({
      name: 'salesPartner',
      label: this.translate.instant('organizations.company_form.sales_partner'),
      type: ProdFormFieldType.TEXT,
    }),
    ProdFormField.create({
      name: 'timezone',
      label: this.translate.instant('organizations.company_form.timezone'),
      type: ProdFormFieldType.SELECT,
      selectParameters: {
        selectDataService: TimezoneService,
        isMulti: false,
        isNarrowDown: true,
        isComplete: true
      }
    }),
    ProdFormField.create({
      name: 'warningLimit',
      label: this.translate.instant('organizations.company_form.warning_limit'),
      type: ProdFormFieldType.NUMBER,
    }),
    ProdFormField.create({
      name: 'alertLimit',
      label: this.translate.instant('organizations.company_form.alert_limit'),
      type: ProdFormFieldType.NUMBER,
    }),
    ProdFormField.create({
      name: 'equipmentUnknownAfter',
      label: this.translate.instant('organizations.company_form.equipment_unknown_after'),
      type: ProdFormFieldType.NUMBER,
    }),
    ProdFormField.create({
      name: 'organizationType',
      label: '',
      type: ProdFormFieldType.HIDDEN,
      value: 1, // Company
      isEditable: false
    }),
  ];

  constructor(override dataService: OrganizationService, private translate: TranslateService) {
    super();
  }
}
